<template>
  <div class="container">
    <el-row>
      <el-col :span="3">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                     :rr-type="this.rr_type" title="原始记录（CMA）"
                     :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
      </el-col>
      <el-col :span="21">
        <div class="form-style">
          <el-form style="margin: 0px" ref="form" :model="form" :inline="true" size="mini">
            <el-form-item label="仪器名称">
              <el-input v-model="form.yqmc1" disabled></el-input>
            </el-form-item>
            <el-form-item label="仪器编号+校准有效期">
              <el-select style="width: 100%" v-model="form.yqbh1jzyxq1" @change="yq1Change"
                         placeholder="请选择">
                <el-option v-for="item in yq1Options" :key="item.value" :label="item.label"
                           :value="item.value">
                  <span style="float: left">{{ item.label | yq_spilt1(item.label) }}</span>
                  <span
                      style="float: right; color: #8492a6; font-size: 13px">{{
                      item.label | yq_spilt2(item.label)
                    }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="仪器名称">
              <el-input v-model="form.yqmc2" disabled></el-input>
            </el-form-item>
            <el-form-item label="仪器编号+校准有效期">
              <el-select style="width: 100%" v-model="form.yqbh2jzyxq2" @change="yq2Change"
                         placeholder="请选择">
                <el-option v-for="item in yq2Options" :key="item.value" :label="item.label"
                           :value="item.value">
                  <span style="float: left">{{ item.label | yq_spilt1(item.label) }}</span>
                  <span
                      style="float: right; color: #8492a6; font-size: 13px">{{
                      item.label | yq_spilt2(item.label)
                    }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="环境温度（℃）">
              <el-input v-model="form.hjwd" placeholder="℃"></el-input>
            </el-form-item>
            <el-form-item label="相对湿度（﹪RH）">
              <el-input v-model="form.xdsd" placeholder="﹪RH"></el-input>
            </el-form-item>
            <el-form-item label="天气">
              <el-input v-model="form.tq"></el-input>
            </el-form-item>
            <el-form-item label="测试电压值（V）">
              <el-input v-model="form.csdyz" placeholder="V"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button v-if="inspect_status" size="mini" type="success" @click="handleFormSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-button v-if="inspect_status" size="mini" type="primary" @click="handleAdd">新增</el-button>

        <el-table :data="tableData" :header-cell-style="{background:'#B4DDD1',color:'#555'}"
                  style="width: 100%;margin-top:20px;">
          <el-table-column border label="序号" prop="id"></el-table-column>
          <el-table-column border label="被检测设备位置" prop="bjcsbwz" show-overflow-tooltip
                           min-width="200"></el-table-column>
          <el-table-column border label="被检测设备名称" prop="bjcsbmc" show-overflow-tooltip
                           min-width="200"></el-table-column>
          <el-table-column border label="A-B实测阻值(MΩ)" prop="absczz"></el-table-column>
          <el-table-column border label="B-C实测阻值(MΩ)" prop="bcsczz"></el-table-column>
          <el-table-column border label="C-A实测阻值(MΩ)" prop="casczz"></el-table-column>
          <el-table-column border label="A-PE实测阻值(MΩ)" prop="apesczz"></el-table-column>
          <el-table-column border label="B-PE实测阻值(MΩ)" prop="bpesczz"></el-table-column>
          <el-table-column border label="C-PE实测阻值(MΩ)" prop="cpesczz"></el-table-column>
          <el-table-column border label="检测结果" prop="jcjg"></el-table-column>
          <el-table-column border label="隐患等级" prop="level"></el-table-column>
          <el-table-column border label="图片" prop="images">
            <template v-slot="scope">
              <img :src="scope.row.url" width="70" height="70" @click="previewPic(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column border label="操作" min-width="120" fixed="right">
            <template v-slot="scope">
              <el-button v-if="inspect_status" type="text" size="mini" @click="handleEdit(scope.row)">修改</el-button>
              <el-button v-if="inspect_status" type="text" size="mini" style="color: red"
                         @click="handleDelete(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
                       :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
      </el-col>
    </el-row>
    <!--对话框-->
    <el-dialog title="新增" :visible.sync="addModel.addShow" width="800px" @close="onAddClose">
      <el-form :model="addModel" label-width="150px" size="small">
        <el-form-item label="被检测设备位置">
          <el-input v-model="addModel.bjcsbwz"></el-input>
        </el-form-item>
        <el-form-item label="被检测设备名称">
          <el-input v-model="addModel.bjcsbmc"></el-input>
        </el-form-item>
        <el-form-item label="A-B">
          <el-input v-model="addModel.absczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="B-C">
          <el-input v-model="addModel.bcsczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="C-A">
          <el-input v-model="addModel.casczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="A-PE">
          <el-input v-model="addModel.apesczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="B-PE">
          <el-input v-model="addModel.bpesczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="C-PE">
          <el-input v-model="addModel.cpesczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="检测结果">
          <el-input v-model="addJg" placeholder="检测结果" disabled></el-input>
        </el-form-item>
        <el-form-item label="隐患等级">
          <el-input v-model="addLevel" placeholder="隐患等级" disabled></el-input>
        </el-form-item>
        <el-form-item label="图片(符合要求不用传)">
          <el-upload action="https://dq-back.wzfire.com/upload_file"
                     name="upload_file"
                     ref="upload"
                     :limit="1"
                     :on-remove="handleRemove"
                     :on-success="uploadSuccess"
                     :headers="headers"
                     accept=".jpeg,.jpg,.png"
                     :data="uploadData"
          >
            <el-button size="small" type="warning">上传图片</el-button>
            <div slot="tip" class="el-upload__tip">只能上传1张jpg/png文件，且不超过10M</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onAdd">新增</el-button>
          <el-button type="info" @click="onAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="修改" :visible.sync="editModel.editShow" width="800px" @close="onEditClose">
      <el-form v-model="editModel" label-width="120px" size="small">
        <el-form-item label="被检测设备位置">
          <el-input v-model="editModel.bjcsbwz" disabled></el-input>
        </el-form-item>
        <el-form-item label="被检测设备名称">
          <el-input v-model="editModel.bjcsbmc" disabled></el-input>
        </el-form-item>
        <el-form-item label="A-B">
          <el-input v-model="editModel.absczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="B-C">
          <el-input v-model="editModel.bcsczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="C-A">
          <el-input v-model="editModel.casczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="A-PE">
          <el-input v-model="editModel.apesczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="B-PE">
          <el-input v-model="editModel.bpesczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="C-PE">
          <el-input v-model="editModel.cpesczz" placeholder="实测阻值"></el-input>
        </el-form-item>
        <el-form-item label="检测结果">
          <el-input v-model="editJg" disabled></el-input>
        </el-form-item>
        <el-form-item label="隐患等级">
          <el-input v-model="editLevel" disabled></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onEdit">修改</el-button>
          <el-button type="info" @click="onEditClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--预览图片-->
    <el-dialog :visible.sync="pictureModel.dialogVisible" :modal="false" v-model="pictureModel" title="图片预览"
               width="50%">
      <img :src="pictureModel.previewpic" alt="" width="100%"/>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="pictureModel.dialogVisible = false">确定</el-button>
          </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";

let token = Vue.$Config.userinfo.token

export default {
  data() {
    return {
      headers: {Authorization: token},
      uploadData: {
        project_id: '',
        site_id: '',
        site_type: '',
      },
      project_id: '',
      site_id: '',
      site_type: '',
      rr_type: 'record',
      inspect_status: false,
      pagination: {current_page: 1, total: 1, per_page: 10,},
      form: {
        yqmc1: '绝缘电阻测试仪',
        yqbh1: '',
        jzyxq1: '',
        yqmc2: '数字温湿度计',
        yqbh2: '',
        jzyxq2: '',
        hjwd: '',
        xdsd: '',
        tq: '',
        csdyz: '',
        yqbh1jzyxq1: '',
        yqbh2jzyxq2: ''
      },
      yq1Options: [],
      yq2Options: [],
      tableData: [],
      addModel: {
        addShow: false,
        bjcsbwz: '',
        bjcsbmc: '',
        absczz: '',
        bcsczz: '',
        casczz: '',
        apesczz: '',
        bpesczz: '',
        cpesczz: '',
        image_ids: []
      },
      editModel: {
        id: '',
        editShow: false,
        bjcsbwz: '',
        bjcsbmc: '',
        absczz: '',
        bcsczz: '',
        casczz: '',
        apesczz: '',
        bpesczz: '',
        cpesczz: '',
      },
      pictureModel: {
        dialogVisible: false,
        previewpic: '',
      },
    }
  },
  methods: {
    //预览图片
    previewPic(row) {
      this.pictureModel.previewpic = row.url
      this.pictureModel.dialogVisible = true
    },
    handleRemove(file, fileList) {
      try {
        this.addModel.image_ids.filter(item => item !== file.response.data.file_id)
        this.$Api.post('del_upload_file', {id: file.response.data.file_id})
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    uploadSuccess(response, file, fileList) {
      this.addModel.image_ids.push(response.data.file_id)
    },
    async getYq1() {
      try {
        this.yq1Options = []
        this.yqbh1jzyxq1 = ""
        let yq1 = await this.$Api.post('get_device_info', {
          'device_name': this.form.yqmc1
        })
        yq1.forEach(item => {
          this.yq1Options.push({
            label: item.device_id + ',' + item.calibrate_date,
            value: item.device_id + ',' + item.calibrate_date
          })
        })
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getYq2() {
      try {
        this.yq2Options = []
        this.yqbh1jzyxq1 = ""
        let yq2 = await this.$Api.post('get_device_info', {
          'device_name': this.form.yqmc2
        })
        yq2.forEach(item => {
          this.yq2Options.push({
            label: item.device_id + ',' + item.calibrate_date,
            value: item.device_id + ',' + item.calibrate_date
          })
        })
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    yq1Change(val) {
      this.form.yqbh1jzyxq1 = val
      this.$forceUpdate()
    },
    yq2Change(val) {
      this.form.yqbh2jzyxq2 = val
      this.$forceUpdate()
    },
    //提交保存表单
    async handleFormSubmit() {
      try {
        let params = this.form
        params.project_id = this.project_id
        params.site_id = this.site_id
        if (this.form.yqbh1jzyxq1) {
          let yq_arr = this.form.yqbh1jzyxq1.split(',')
          params.yqbh1 = yq_arr[0]
          params.jzyxq1 = yq_arr[1]
        }
        if (this.form.yqbh2jzyxq2) {
          let yq_arr = this.form.yqbh2jzyxq2.split(',')
          params.yqbh2 = yq_arr[0]
          params.jzyxq2 = yq_arr[1]
        }
        await this.$Api.post('record_cma_jydz1', params)
        this.$message.success('提交成功')
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //新增
    handleAdd() {
      this.addModel.addShow = true
    },
    async onAdd() {
      try {
        let params = this.addModel
        delete params.addShow
        params.project_id = this.project_id
        params.site_id = this.site_id
        params.jcjg = this.addJg
        params.level = this.addLevel
        params.image_ids = this.addModel.image_ids.join(',')
        await this.$Api.post('record_cma_jydz', params)
        this.$message.success('新增成功')
        location.reload()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onAddClose() {
      this.addModel.addShow = false
      this.initModel(this.addModel)
    },
    //编辑
    handleEdit(row) {
      Object.keys(row).forEach(key => {
        if (this.editModel.hasOwnProperty(key)) {
          this.editModel[key] = row[key]
        }
      })
      this.editModel.editShow = true
    },
    async onEdit() {
      try {
        let params = this.editModel
        delete params.editShow
        params.project_id = this.project_id
        params.site_id = this.site_id
        params.jcjg = this.editJg
        params.level = this.editLevel
        await this.$Api.post('edit_record_cma_jydz', params)
        this.$message.success('编辑成功')
        this.initModel(this.editModel)
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onEditClose() {
      this.editModel.editShow = false
      this.initModel(this.editModel)
    },
    //删除
    handleDelete(row) {
      this.$confirm('确认删除?', '确认删除', {
        confirmButtonClass: '确认',
        cancelButtonClass: '取消',
        type: 'warning'
      }).then(
          async () => {
            try {
              await this.$Api.post('del_record_cma_jydz', {'id': row.id})
              this.$message.success('删除成功')
              await this.getList()
            } catch (e) {
              this.$message.error(e.errormsg)
            }
          }
      )
    },
    //初始化对话框
    initModel(model) {
      Object.keys(model).forEach(key => {
        if (key === 'addShow' || key === 'editShow') {
          model[key] = false
        } else if (key === 'image_ids') {
          model[key] = []
        } else {
          model[key] = ''
        }
      })
    },

    async getForm() {
      try {
        this.loading = true;
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
        }
        let res = await this.$Api.get("record_cma_jydz1", {params: params});
        if (res) {
          this.form = res
          if (this.form.yqbh1 && this.form.jzyxq1) {
            this.form.yqbh1jzyxq1 = this.form.yqbh1 + ',' + this.form.jzyxq1
          }
          if (this.form.yqbh2 && this.form.jzyxq2) {
            this.form.yqbh2jzyxq2 = this.form.yqbh2 + ',' + this.form.jzyxq2
          }
        }

        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("record_cma_jydz", {params: params});
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: Number(data.per_page)
        }
        this.tableData = data.data;
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    changePage() {
      this.getList();
    },
    //设置操作按钮的状态
    async setButtonStatus() {
      try {
        let res = await this.$Api.post('get_site_status', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          status_type: 'cma'
        })
        if (res) {
          if (res === '检测中' || res === '已完成') {
            this.inspect_status = true
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    }
  },
  filters: {
    yq_spilt1: function (str) {
      let arr = str.split(",")
      return arr[0]
    },
    yq_spilt2: function (str) {
      let arr = str.split(",")
      return arr[1]
    }
  },
  computed: {
    addJg() {
      if (this.addModel.absczz < 0.5 || this.addModel.bcsczz < 0.5 || this.addModel.casczz < 0.5 || this.addModel.apesczz < 0.5 || this.addModel.bpesczz < 0.5 || this.addModel.cpesczz < 0.5) {
        return '线路的线间和线对地间绝缘电阻值小于0.5MΩ'
      } else {
        return '符合要求'
      }
    },
    addLevel() {
      if (this.addJg !== '符合要求') {
        return 'A'
      } else {
        return '--'
      }
    },
    editJg() {
      if (this.editModel.absczz < 0.5 || this.editModel.bcsczz < 0.5 || this.editModel.casczz < 0.5 || this.editModel.apesczz < 0.5 || this.editModel.bpesczz < 0.5 || this.editModel.cpesczz < 0.5) {
        return '线路的线间和线对地间绝缘电阻值小于0.5MΩ'
      } else {
        return '符合要求'
      }
    },
    editLevel() {
      if (this.editJg !== '符合要求') {
        return 'A'
      } else {
        return '--'
      }
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.uploadData.project_id = this.$route.params.project_id
    this.uploadData.site_id = this.$route.params.site_id
    this.uploadData.site_type = this.$route.params.site_type
    this.setButtonStatus()
    this.getForm()
    this.getList()
    this.getYq1()
    this.getYq2()
  }
}
</script>
<style scoped>
table {
  width: 100%;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  vertical-align: middle !important;
}
</style>

<style scoped>
.form-style {
  margin: 12px 0;
  border: 1px solid #028D66;
  padding: 24px 0 0 24px;
  background-color: #ffffff;
}
</style>
